import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { ProductsContextProvider } from "../../Context/ProductsContext";
import PriceListForm from "./PriceListForm";
import Body from "../../Common/Body";

const NewPriceList = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [priceList, setPriceList] = useState({});
  const { id } = useParams();

  useEffect(() => {
    setPriceList({
      name: "",
      description: "",
      active: 1,
    });
    setIsLoading(false);
  }, []);

  return (
    <>
      <ProductsContextProvider>
        <Body title={"Nuevo lista de precios"} isLoading={isLoading}>
          <PriceListForm priceList={priceList} id={id}></PriceListForm>
        </Body>
      </ProductsContextProvider>
    </>
  );
};

export default NewPriceList;
